export default "__VITE_ASSET__2a89bb45__"